import { Component, OnInit, ViewChild } from '@angular/core';
import { DictionaryRest } from '../../../../dictionaries/dictionary/dictionary.rest';
import { Customer, CustomerWatcher } from '../../customers.model';
import { NgForm } from '@angular/forms';
import { SpinEditComponent } from '../../../../core/shared/spinedit/spinedit.component';
import { SelectionMode } from '../../../../core/shared/grid/grid.model';
import { EmployeesListComponent } from '../../../employees/employee-list/employees-list.component';
import { GridComponent } from '../../../../core/shared/grid/grid.component';
import { CustomersRest } from '../../customers.rest';
import { DialogService } from '../../../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../../../core/shared/dialog/dialog-config';
import { DateInputModel } from '../../../../core/shared/date-input/date-input.model';

@Component({
  selector: 'app-customer-details-header',
  templateUrl: './customer-details-header.component.html',
  styleUrls: ['./customer-details-header.scss']
})
export class CustomerDetailsHeaderComponent implements OnInit {

  constructor(
    private rest: CustomersRest,
    private dictionaryRest: DictionaryRest,
    public dialog: DialogService) { }

  public customer: Customer;
  public isAddedCustomer: boolean;
  public isNew: boolean;
  public isDialogActive: boolean = false;
  public blockedDate: DateInputModel;
  private isEditable: boolean;
  private vstsProjects: any = [{ 'value': '', 'id': 0 }];
  private erpVstsProjects: any = [{ 'value': '', 'id': 0 }];
  private watchersHeaders = [
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
  ];

  @ViewChild('customerForm') customerForm: NgForm;
  @ViewChild('hourlyRate') hourlyRate: SpinEditComponent;
  @ViewChild('distanceToCustomer') distanceToCustomer: SpinEditComponent;
  @ViewChild(GridComponent) watchersGrid: GridComponent;

  ngOnInit() {
    this.dictionaryRest.getDictionaries(9).subscribe(vstsProjects => {
      this.vstsProjects = vstsProjects;
    });
    this.dictionaryRest.getDictionaries(10).subscribe(erpVstsProjects => {
      this.erpVstsProjects = erpVstsProjects;
    });
  }

  public setModel(customer: Customer, isNew: boolean, isEditable: boolean) {
    this.customer = customer;
    this.isNew = isNew;
    this.isEditable = isEditable;
    if (this.customer.blockedDate != null) {
      this.initializeDate()
    }
  }

  private initializeDate() {
    this.blockedDate = new DateInputModel();
    this.blockedDate.isReadOnly = true;
    this.blockedDate.isRequired = false;
    this.blockedDate.name = 'Data zablokowania';
    this.blockedDate.value = new Date(this.customer.blockedDate);
    this.blockedDate.valueStr = this.blockedDate.value.toDateString();
    this.blockedDate.withTime = false;
    this.blockedDate.internalName = 'customerBlockedDate';
  }


  public isSmallerThan(value: number) {
    return value <= 0;
  }

  public onHourlyRateChange(event: number) {
    this.customer.hourlyRate = event;
  }

  public onDistanceToCustomerChange(event: number) {
    this.customer.distanceToCustomer = event;
  }
  public onErpIdChange(event: number) {
    this.customer.erpId = event;
  }

  private checkSaveCondition() {
    if (!this.hourlyRate.isValid) {
      return false;
    }
    if (!this.distanceToCustomer.isValid) {
      return false;
    }
    return true;
  }

  public isInvalid() {
    if (this.checkSaveCondition()) {
      return this.customerForm.invalid;
    }
    return true;
  }

  public addWatcher() {
    const dialogconf = new DialogConfig();
    dialogconf.title = 'Wybierz Obserwatorów';
    dialogconf.selectionMode = SelectionMode.multi;
    dialogconf.maxwidth = '1000px';
    this.isDialogActive = true;
    const ref = this.dialog.open(EmployeesListComponent, dialogconf);
    ref.afterClosed.subscribe(result => {
      this.isDialogActive = false;
      if (result != null) {
        result.forEach(element => {
          const watcher = new CustomerWatcher;
          watcher.customerId = this.customer.id;
          watcher.employeeFullName = element.fullName;
          watcher.employeeId = element.id;
          this.customer.customerWatchers.push(watcher);
        });
        this.watchersGrid.refreshData();
      }
    });
  }

  private removeWatcher(row: CustomerWatcher) {
    if (row.id != null) {
      const action = this.rest.removeWatcher;
      action.call(this.rest, row.id).subscribe();
    }
    this.customer.customerWatchers.splice(this.customer.customerWatchers.indexOf(row), 1);
    this.watchersGrid.refreshData();
  }
}
